import RecapModal from "./RecapModal";

export default RecapModal;